export const CONFIRMATION_OVERLAY_WIDTH = 1500;
export const CONFIRMATION_OVERLAY_HEIGHT = 1080;
export const CONFIRMATION_BOX_WIDTH = 1000;
export const CONFIRMATION_BOX_HEIGHT = 250;
export const CONFIRMATION_BOX_RADIUS = 50;
export const CONFIRMATION_ACTIONS_WIDTH = 500;
export const CONFIRMATION_ACTIONS_HEIGHT = 100;
export const CONFIRMATION_TEXT_FONT_SIZE = 24;
export const CONFIRMATION_TEXT_MAX_WIDTH = 860;
export const CONFIRMATION_Z_INDEX = 5;
